import React from 'react';
import { Select } from 'antd';
import ReactCountryFlag from 'react-country-flag';

import './countrySelect.scss';

import { getData, overwrite } from 'country-list';

const { Option } = Select;

overwrite([
    {
        code: 'TR',
        name: 'Türkiye',
    },
]);

function CountrySelect(props) {
    const { country, setCountry, disabled } = props;

    const handleCountrySelection = (data) => {
        setCountry(data);
    };

    const renderCountryFlag = (country) => {
        return (
            <ReactCountryFlag
                countryCode={country.code}
                aria-label={country.name}
                svg
            />
        );
    };

    return (
        <Select
            showSearch
            style={{ width: '100%' }}
            value={country}
            placeholder="Select a country"
            onChange={handleCountrySelection}
            disabled={disabled}
        >
            {getData().map((country, i) => {
                return (
                    <Option key={country?.name}>
                        {renderCountryFlag(country)}
                        <span className="ml-1">{country.name}</span>
                    </Option>
                );
            })}
        </Select>
    );
}

export default CountrySelect;
